import SysDialog from "./SysDialog.vue"
import SysLoading from "./SysLoading"
import SysSwiper from "./SysSwiper"
import captcha from "./captcha.vue";

const sysDialog = {
  install: Vue => {
    Vue.component("SysDialog", SysDialog);
  }
};

const sysLoading = {
  install: Vue => {
    Vue.component("SysLoading", SysLoading);
  }
};

const sysSwiper = {
  install: Vue => {
    Vue.component("vCaptcha", captcha);
    Vue.component("SysSwiper", SysSwiper);
  }
};


export {sysDialog, sysLoading, sysSwiper, renderDialog}



// WEBPACK FOOTER //
// ./src/components/common/index.js